var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorbars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m504.5 112.5c0-8.25-6.75-15-15-15h-56l-10 202.736 81-10z",
    fill: "#7398d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m433.5 290.236v-192.736h-71l-10 202.736z",
    fill: "#d16161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.5 290.236v-192.736h-71l-10 202.736z",
    fill: "#e6989e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.5 290.236v-192.736h-71l-10 202.736z",
    fill: "#e3a93f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.5 290.236v-192.736h-71l-10 202.736z",
    fill: "#9ec8fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.5 290.236v-192.736h-71l-10 202.736z",
    fill: "#ffe07d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.5 290.236v-192.736h-51l-10 202.736z",
    fill: "#f5fcff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.5 97.5h-5c-8.284 0-15 6.716-15 15v177.736h20z",
    fill: "#d3effd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m504.5 394.486-487 10 10-78.75 51-35.5h71l31.18 35.5 39.82-35.5h71l31.74 35.5 39.26-35.5h71l71 35.5z",
    fill: "#909ba6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.5 325.736h23.667v70.937h-23.667z",
    fill: "#5f6c75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m409.833 325.736h23.667v70.937h-23.667z",
    fill: "#b9c3cd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35 394.5c-4.142 0-7.5-3.358-7.5-7.5v-71.264l-20 10v73.764c0 8.284 6.716 15 15 15h73.75l120.601-12.822 56.899 12.822h215.75c8.284 0 15-6.716 15-15v-5z",
    fill: "#5f6c75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185 325.736h88.75v68.764l-98.75 10z",
    fill: "#9d66d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175 394.5 10 20h88.75v-20z",
    fill: "#744b9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.25 325.736h88.75v68.764l-44.375 7.472-44.375-7.472z",
    fill: "#f5fcff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.25 394.5h88.75v20h-88.75z",
    fill: "#d3effd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m433.5 290.236h71v35.5h-71z",
    fill: "#f5fcff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.5 290.236h71v35.5h-71z",
    fill: "#9ec8fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.5 290.236h71v35.5h-71z",
    fill: "#e6989e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.5 325.736h-51l-10-17.75 10-17.75h51z",
    fill: "#7398d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5 290.236h20v35.5h-20z",
    fill: "#4377c4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m489.5 422h-467c-12.407 0-22.5-10.094-22.5-22.5v-194.194c0-4.143 3.358-7.5 7.5-7.5s7.5 3.357 7.5 7.5v77.431h56v-177.737h-48.5c-4.136 0-7.5 3.364-7.5 7.5v62.806c0 4.143-3.358 7.5-7.5 7.5s-7.5-3.357-7.5-7.5v-62.806c0-12.406 10.093-22.5 22.5-22.5h360.5c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5h-13v177.736h56v-177.736h-13c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h76.5c12.407 0 22.5 10.094 22.5 22.5v287c0 12.406-10.093 22.5-22.5 22.5zm-48.5-15h48.5c4.136 0 7.5-3.364 7.5-7.5v-66.264h-56zm-71 0h56v-73.764h-56v21.875c0 4.143-3.358 7.5-7.5 7.5s-7.5-3.357-7.5-7.5v-21.875h-73.75v73.764h73.75v-21.889c0-4.143 3.358-7.5 7.5-7.5s7.5 3.357 7.5 7.5zm-177.5 0h73.75v-73.764h-73.75zm-88.75 0h73.75v-73.764h-73.75zm-88.75-73.764v66.264c0 4.136 3.364 7.5 7.5 7.5h66.25v-73.764zm426-15h56v-20.5h-56zm-71 0h56v-20.5h-56zm-71 0h56v-20.5h-56zm-71 0h56v-20.5h-56zm-71 0h56v-20.5h-56zm-71 0h56v-20.5h-56zm-71 0h56v-20.5h-56zm426-35.5h56v-170.236c0-4.136-3.364-7.5-7.5-7.5h-48.5zm-142 0h56v-177.736h-56zm-71 0h56v-177.736h-56zm-71 0h56v-177.736h-56zm-71 0h56v-177.736h-56z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorbars);
export default __webpack_public_path__ + "static/media/colorbars.3a19c87ffe39294ee96bb7c750dd06f5.svg";
export { ForwardRef as ReactComponent };